import { formatCustomDateTime } from './date.helper';

export const getVacationPeriod = (startDateString?: string | null, endDateString?: string | null): string | null => {
  if (!startDateString || !endDateString) {
    return null;
  }

  return `${formatCustomDateTime(startDateString)} - ${formatCustomDateTime(endDateString)}`;
};
